<template>
    <widgets-list-row-view v-if="mode === 'list'"
        :widgets="widgets"
        :view-privilege="viewPrivilege"
        :manage-privilege="managePrivilege"
    />
    <div v-else class="widgets-frame" :class="listClass">
        <v-container fluid>
            <v-row dense class="widgets-list">
                <template v-for="(widget,key) in widgets">
                    <widgets-element
                        :widget="widget"
                        :view-privilege="viewPrivilege"
                        :manage-privilege="managePrivilege"
                        :small="small"
                        :mode="mode"
                        :key="key"
                        :drag-drop="dragDrop"
                        :element-class="elementClass"
                    />
                </template>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import widgetsElement from './widget-element-tile.vue';
    import WidgetsListRowView from "./widgets-list-row-view.vue";

    export default {
        name: 'widgets-list',
        components: {
            WidgetsListRowView,
            widgetsElement
        },
        data() {
            return {
                mode: 'tiles'
            }
        },
        props: [
            'widgets',
            'small',
            'classes',
            'forceMode',
            'viewPrivilege',
            'managePrivilege',
            'elementClass',
            'dragDrop'
        ],
        computed: {
            listClass: function () {
                return this.classes + ' col-md-12';
            }
        },
        mounted() {
            if (this.forceMode) {
                this.mode = this.forceMode;
            } else {
                this.mode = localStorage.getItem('widgets-mode-' + Laravel.activeProject) ?? 'tiles';
            }

            EaseEventBus.listen('widgetsMode', (mode) => {
                this.mode = mode;
            });
        }
    }
</script>

<style>
    .widgets-list {
        gap: 16px;
    }

    .widgets-list::before, .widgets-list::after {
        content: unset !important;
    }

    .widgets-list .col-2 {
        flex: 0;
    }
</style>
